import PropTypes from 'prop-types'
import Container from '@material-ui/core/Container'
import Typography from '@material-ui/core/Typography'
import { RenderRichText } from '@components/renderers'
import Box from '@material-ui/core/Box'
import useStyles from './cards-section.styles'
import Image from '../atoms/image'

const CardsSection = (props) => {
  const {
    heading, eyebrow, cardsCollection, summary, headingAlignment,
  } = props

  const styles = useStyles({ headingAlignment })

  return (
    <div className={styles.root}>
      <div className={styles.backgroundOverlay} />
      <Container className={styles.content}>
        <div className={styles.titleContainer}>
          <div className={styles.titleTextWrapper}>
            {eyebrow && (
              <Typography variant="overline" className={styles.supportText}>
                {eyebrow}
              </Typography>
            )}
            {heading && (
              <Typography variant="h3" className={styles.headline}>
                {heading}
              </Typography>
            )}
            {summary && (
              <div className={styles.richTextWrapper}>
                <RenderRichText {...summary} />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.eventCardContainer} ${styles.centered}`}>
          {cardsCollection.items.map(card => (
            <div className={styles.eventCard} key={card.heading}>
              {card?.image?.url && (
                <div className={styles.cardImage}>
                  {card.imageUrl ? (
                    <a href={card.imageUrl}>
                      <Image src={`${card.image.url}?w=300`} alt="" />
                    </a>
                  ) : (
                    <Image src={`${card.image.url}?w=300`} alt="" />
                  )}
                </div>
              )}
              <div className={styles.textContainer}>
                <Box mb={2}>
                  {card.heading && (
                    <Typography variant="h6">{card.heading}</Typography>
                  )}
                </Box>
                {card.summary ? (
                  <RenderRichText {...card.summary} />
                ) : (
                  <Typography className={styles.description} variant="body1">
                    {card.eyebrow}
                  </Typography>
                )}
              </div>
            </div>
          ))}
        </div>
      </Container>
    </div>
  )
}

CardsSection.propTypes = {
  heading: PropTypes.string,
  eyebrow: PropTypes.string,
  cardsCollection: PropTypes.object,
  summary: PropTypes.object,
  headingAlignment: PropTypes.string,
}

export default CardsSection
